import { useCallback, useEffect } from 'react';
import { reactEvents } from '@bridge/reactEvents';
import { variantsApi } from '@texas/api/endpoints/variantsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useSignalSubscriptionEvents } from '@texas/components/shared/hooks/useSignalSubscriptionEvents';
import { articleManageEvents } from '@texas/components/article/manage/events';
import { complianceDocumentDefinitionEvents } from '@texas/components/configuration/complianceDocumentDefinitions/events';
import { supplierComplianceDocumentEvents } from '@texas/components/suppliers/complianceDocuments/events';

const reloadEvents = [
  articleManageEvents.branchesModified,
  complianceDocumentDefinitionEvents.changed,
  reactEvents.variantSupplierChanged,
  reactEvents.supplierArchived,
  reactEvents.supplierRestored,
  reactEvents.supplierNameChanged,
];

export function useVariantComplianceCoverage(
  articleId: number,
  variantId: number,
) {
  const resource = useApiResource(variantsApi.getComplianceCoverage);
  const { refetch, data } = resource;
  const reload = useCallback(() => {
    void refetch(variantId);
  }, [refetch, variantId]);

  useEffect(() => {
    reload();
  }, [reload]);
  useEffect(
    () =>
      supplierComplianceDocumentEvents.changed.subscribe((supplierId) => {
        if (
          data?.branches.some((branch) =>
            branch.suppliers.some((supplier) => supplier.id === supplierId),
          )
        )
          reload();
      }),
    [data, reload],
  );
  useEffect(
    () =>
      articleManageEvents.certificatesModified.subscribe((id) => {
        if (id === articleId) reload();
      }),
    [articleId, reload],
  );
  useSignalSubscriptionEvents({
    triggerOnEvent: reload,
    signalEvents: reloadEvents,
  });

  return resource;
}
